module.exports = require('./input');

module.exports.PublicKey = require('./publickey');
module.exports.PublicKeyHash = require('./publickeyhash');
module.exports.MultiSig = require('./multisig.js');
module.exports.MultiSigScriptHash = require('./multisigscripthash.js');



//////////////////
// WEBPACK FOOTER
// ./~/bitcore-lib/lib/transaction/input/index.js
// module id = 336
// module chunks = 0